import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import DesktopSubmissionDetails from './DesktopSubmissionDetails';
import DesktopSubmissionDetails_das from './DesktopSubmissionDetails.digital_assets';
export default withFeatureBranch({
    digital_assets: DesktopSubmissionDetails_das
})(DesktopSubmissionDetails);
